module.exports = __webpack_public_path__ + "static/media/venus.9dc6329d.png";